import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { PedidoMotivoNaoLiberadoPipe } from './pedido-motivo-nao-liberado.pipe';
import { PedidoMotivoNaoLiberadoAbreviacaoPipe } from './pedido-motivo-nao-liberado-abreviacao.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PedidoMotivoNaoLiberadoAbreviacaoPipe,
        PedidoMotivoNaoLiberadoPipe
    ],
    exports: [
        PedidoMotivoNaoLiberadoAbreviacaoPipe,
        PedidoMotivoNaoLiberadoPipe
    ],
    providers: [
        PedidoMotivoNaoLiberadoAbreviacaoPipe,
        PedidoMotivoNaoLiberadoPipe
    ]
})
export class PedidoNaoLiberadoPipeModule { }
